import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthContext } from '../context/AuthContext'

type Props = {
  children: React.ReactNode
}
export default function PrivateRoute(props: Props) {
  const { auth } = useAuthContext()

  if (auth) {
    return (
      <>
        {props.children}
      </>
    )
  } else {
    return <Navigate to='/auth' />    
  }
}